"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Vr360RemoteController: ['vr-360-remote-controller', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.75,7h-3a1.5,1.5,0,0,0-1.5,1.5v14A1.5,1.5,0,0,0,7.75,24h3a1.5,1.5,0,0,0,1.5-1.5V8.5A1.5,1.5,0,0,0,10.75,7Zm-1.5,7a2,2,0,1,1,2-2A2,2,0,0,1,9.25,14Z', 'M8.500 12.000 A0.750 0.750 0 1 0 10.000 12.000 A0.750 0.750 0 1 0 8.500 12.000 Z', 'M4.466,9.892a.75.75,0,1,0-.432-1.436A10.9,10.9,0,0,0,2.587,9a.25.25,0,0,1-.33-.335,7.754,7.754,0,0,1,8.361-4.291.75.75,0,0,0,.264-1.477A9.244,9.244,0,0,0,3.809,19.469a.749.749,0,1,0,.882-1.212,7.779,7.779,0,0,1-2.425-2.915.25.25,0,0,1,.33-.335,10.962,10.962,0,0,0,1.438.537.75.75,0,1,0,.432-1.436C2.664,13.567,1.5,12.74,1.5,12S2.664,10.433,4.466,9.892Z', 'M15.671,6.394a.751.751,0,0,0-.163,1.049A7.889,7.889,0,0,1,16.24,8.66.251.251,0,0,1,15.909,9a10.654,10.654,0,0,0-1.443-.54.75.75,0,1,0-.432,1.436C15.836,10.433,17,11.26,17,12s-1.164,1.567-2.966,2.108a.751.751,0,0,0-.5.934c.29.962.914.509.935.5a10.962,10.962,0,0,0,1.438-.537.25.25,0,0,1,.33.335,7.779,7.779,0,0,1-2.425,2.915.75.75,0,0,0-.165,1.048c.517.706.843.314,1.047.164A9.277,9.277,0,0,0,18.5,12a9.163,9.163,0,0,0-1.781-5.443A.75.75,0,0,0,15.671,6.394Z', 'M18.5,2a1.491,1.491,0,0,0-.42.06.064.064,0,0,1-.055-.01A.062.062,0,0,1,18,2a1,1,0,0,1,1-1,.5.5,0,0,0,0-1,2,2,0,0,0-2,2V3.5A1.5,1.5,0,1,0,18.5,2Zm0,2a.5.5,0,1,1,.5-.5A.5.5,0,0,1,18.5,4Z', 'M16,3.5a1.491,1.491,0,0,0-.269-.857.25.25,0,0,1,0-.286,1.5,1.5,0,1,0-2.68-1.244.5.5,0,0,0,.967.257A.5.5,0,1,1,14.5,2a.5.5,0,0,0,0,1,.5.5,0,1,1-.482.635.5.5,0,1,0-.963.267A1.5,1.5,0,0,0,16,3.5Z', 'M22.5,0A1.5,1.5,0,0,0,21,1.5v2a1.5,1.5,0,0,0,3,0v-2A1.5,1.5,0,0,0,22.5,0ZM23,3.5a.5.5,0,0,1-1,0v-2a.5.5,0,0,1,1,0Z']],
  VrUserBox1: ['vr-user-box-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.731,5.927,6.206,6.988a.5.5,0,0,0,.657-.657L5.8,3.856A.522.522,0,0,0,5.7,3.7L2.268.271a.5.5,0,0,0-.707,0L.146,1.685a.5.5,0,0,0,0,.708L3.575,5.821A.5.5,0,0,0,3.731,5.927Z', 'M14.573,7.978a.248.248,0,0,0,.178-.24.8.8,0,0,0-.108-.458.76.76,0,0,0-.379-.317L8.823,4.923a.75.75,0,1,0-.527,1.4L11.947,7.7,8,9.314,2.284,6.971a.75.75,0,0,0-1.034.694v6.46a.75.75,0,0,0,.513.711l6,2A.74.74,0,0,0,8,16.875a.954.954,0,0,0,.342-.072.25.25,0,0,0,.169-.25c-.007-.142-.011-.284-.011-.428A8.516,8.516,0,0,1,14.573,7.978Z', 'M23.254,13.067a6.758,6.758,0,0,0-12.5-.005A2,2,0,0,0,10,14.625v3a2,2,0,0,0,2,2h2.5a1,1,0,0,0,.8-.4l.9-1.2a1,1,0,0,1,1.6,0l.9,1.2a1,1,0,0,0,.8.4H22a2,2,0,0,0,2-2v-3A2,2,0,0,0,23.254,13.067ZM14.5,15.625h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Zm3,0h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Zm-4.3-3a.25.25,0,0,1-.19-.412,5.269,5.269,0,0,1,8,0,.25.25,0,0,1-.191.412Z', 'M21.257,21.416a.75.75,0,0,0-1.052-.135,5.319,5.319,0,0,1-6.41,0,.75.75,0,1,0-.916,1.188,6.742,6.742,0,0,0,8.242,0A.751.751,0,0,0,21.257,21.416Z']],
  VrController1: ['vr-controller-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.312,3.833a.25.25,0,0,0,.272.023A2.98,2.98,0,0,1,12,3.5H22a2.98,2.98,0,0,1,1.416.356.25.25,0,0,0,.362-.279c-.268-1.088-.793-3.2-.793-3.2A.5.5,0,0,0,22.5,0H21a.5.5,0,0,0-.354.146A2.892,2.892,0,0,1,18.586,1H15.414a2.892,2.892,0,0,1-2.06-.854A.5.5,0,0,0,13,0H11.5a.5.5,0,0,0-.485.379s-.525,2.11-.793,3.2A.251.251,0,0,0,10.312,3.833Z', 'M22,4.5H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h8v9a.5.5,0,0,1-1,0v-2A2.5,2.5,0,0,0,16.5,16h-1a1,1,0,0,0,0,2h1a.5.5,0,0,1,.5.5v2a2.5,2.5,0,0,0,5,0v-9a2,2,0,0,0,2-2v-3A2,2,0,0,0,22,4.5Zm-8,5A1.5,1.5,0,1,1,15.5,8,1.5,1.5,0,0,1,14,9.5Zm6,0A1.5,1.5,0,1,1,21.5,8,1.5,1.5,0,0,1,20,9.5Z', 'M10,15H3a3,3,0,0,0-3,3v4.5a1.5,1.5,0,0,0,2.7.9l2.462-3.3a.251.251,0,0,1,.2-.1H7.634a.251.251,0,0,1,.2.1L10.3,23.4a1.5,1.5,0,0,0,2.7-.9V18A3,3,0,0,0,10,15ZM2.75,19.5a1,1,0,1,1,1-1A1,1,0,0,1,2.75,19.5Zm7.751,0a1,1,0,1,1,1-1A1,1,0,0,1,10.5,19.5Z']],
  VrController: ['vr-controller', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10,15H3a3,3,0,0,0-3,3v4.5a1.5,1.5,0,0,0,2.7.9l2.462-3.3a.251.251,0,0,1,.2-.1H7.634a.251.251,0,0,1,.2.1L10.3,23.4a1.5,1.5,0,0,0,2.7-.9V18A3,3,0,0,0,10,15ZM2.75,19.5a1,1,0,1,1,1-1A1,1,0,0,1,2.75,19.5Zm7.751,0a1,1,0,1,1,1-1A1,1,0,0,1,10.5,19.5Z', 'M10.312,3.834a.25.25,0,0,0,.271.022A2.987,2.987,0,0,1,12,3.5H22a2.98,2.98,0,0,1,1.416.356.25.25,0,0,0,.362-.28c-.268-1.087-.793-3.2-.793-3.2A.5.5,0,0,0,22.5,0H21a.5.5,0,0,0-.354.146A2.894,2.894,0,0,1,18.585,1H15.414a2.929,2.929,0,0,1-2.06-.854A.5.5,0,0,0,13,0H11.5a.5.5,0,0,0-.485.379s-.525,2.11-.793,3.2A.252.252,0,0,0,10.312,3.834Z', 'M22,4.5H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h8v9a.5.5,0,0,1-1,0v-2A2.5,2.5,0,0,0,16.5,16h-1a1,1,0,0,0,0,2h1a.5.5,0,0,1,.5.5v2a2.5,2.5,0,0,0,5,0v-9a2,2,0,0,0,2-2v-3A2,2,0,0,0,22,4.5Zm-7.5,3h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Zm3,0h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Z']],
  VrUserBoxHuman: ['vr-user-box-human', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.447,3.105l-6-3a1,1,0,0,0-.894,0l-6,3A1.058,1.058,0,0,0,0,4v6.75a1,1,0,0,0,.553.894l6,3a1,1,0,0,0,.894,0l6-3A1,1,0,0,0,14,10.75V4A1.058,1.058,0,0,0,13.447,3.105Zm-3.131.671a.25.25,0,0,1,0,.448l-3.2,1.6a.252.252,0,0,1-.224,0l-3.2-1.6a.25.25,0,0,1,0-.448l3.2-1.6a.252.252,0,0,1,.224,0ZM2,6.023a.25.25,0,0,1,.119-.213A.248.248,0,0,1,2.362,5.8l3.5,1.75A.251.251,0,0,1,6,7.773v3.954a.25.25,0,0,1-.362.224l-3.5-1.75A.251.251,0,0,1,2,9.977Zm6.362,5.928A.25.25,0,0,1,8,11.727V7.773a.251.251,0,0,1,.138-.224l3.5-1.75a.248.248,0,0,1,.243.011A.25.25,0,0,1,12,6.023V9.977a.251.251,0,0,1-.138.224Z', 'M23.522,5.011a7.473,7.473,0,0,0-4.341.973.5.5,0,0,0,.055.88l4.057,1.842A.5.5,0,0,0,24,8.25V5.51A.5.5,0,0,0,23.522,5.011Z', 'M23.438,14.5l-8,1a.5.5,0,0,0-.41.329s-.544,1.538-.7,2.009a.5.5,0,0,0,.475.658h1.613a.25.25,0,0,1,.25.25v.564a2.6,2.6,0,0,0,2.593,2.593h.026a.25.25,0,0,1,.25.25V23.5a.5.5,0,0,0,.5.5H23.5a.5.5,0,0,0,.5-.5V15a.5.5,0,0,0-.169-.375A.49.49,0,0,0,23.438,14.5Z', 'M15.252,14l7.338-.443A1.5,1.5,0,0,0,24,12.059V11.2a1.506,1.506,0,0,0-.978-1.406L17.414,7.7a1.481,1.481,0,0,0-1.6.423,5.387,5.387,0,0,0-1.083,2.252,5.061,5.061,0,0,0,.038,3.345A.5.5,0,0,0,15.252,14Zm2.023-4.747,1.627.522a.5.5,0,0,1,.147.877L16.807,12.32a.5.5,0,0,1-.8-.429A5.728,5.728,0,0,1,16.7,9.469.5.5,0,0,1,17.275,9.252Z']],
  VrLaptop: ['vr-laptop', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.5,21h-.25V16.5a2,2,0,0,0-2-2H2.75a2,2,0,0,0-2,2V21H.5a.5.5,0,0,0-.5.5A2.41,2.41,0,0,0,2.5,24h7A2.41,2.41,0,0,0,12,21.5.5.5,0,0,0,11.5,21Zm-2.25-.25A.25.25,0,0,1,9,21H3a.25.25,0,0,1-.25-.25v-4A.25.25,0,0,1,3,16.5l6,0a.252.252,0,0,1,.177.074.248.248,0,0,1,.073.176Z', 'M10.312,3.834a.25.25,0,0,0,.271.022A2.987,2.987,0,0,1,12,3.5H22a2.98,2.98,0,0,1,1.416.356.25.25,0,0,0,.362-.28c-.268-1.087-.793-3.2-.793-3.2A.5.5,0,0,0,22.5,0H21a.5.5,0,0,0-.354.146A2.894,2.894,0,0,1,18.585,1H15.414a2.929,2.929,0,0,1-2.06-.854A.5.5,0,0,0,13,0H11.5a.5.5,0,0,0-.485.379s-.525,2.11-.793,3.2A.252.252,0,0,0,10.312,3.834Z', 'M22,4.5H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h8v9a.5.5,0,0,1-1,0v-2A2.5,2.5,0,0,0,16.5,16h-3a1,1,0,0,0,0,2h3a.5.5,0,0,1,.5.5v2a2.5,2.5,0,0,0,5,0v-9a2,2,0,0,0,2-2v-3A2,2,0,0,0,22,4.5Zm-7.5,3h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Zm3,0h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Z']],
  VrControllerHeadphones: ['vr-controller-headphones', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.025,6H22V5.95a6,6,0,0,0-12,0V6H9.975A1.977,1.977,0,0,0,8,7.975v1.05A1.977,1.977,0,0,0,9.975,11H11.5a.5.5,0,0,0,.5-.5V5.95a4,4,0,0,1,8,0V10.5a.5.5,0,0,0,.5.5v6.5a.5.5,0,0,1-1,0v-2A2.5,2.5,0,0,0,17,13H16a1,1,0,0,0,0,2h1a.5.5,0,0,1,.5.5v2a2.5,2.5,0,0,0,5,0V10.942A1.978,1.978,0,0,0,24,9.025V7.975A1.977,1.977,0,0,0,22.025,6Z', 'M.312,16.333a.25.25,0,0,0,.272.023A2.98,2.98,0,0,1,2,16H12a2.98,2.98,0,0,1,1.416.356.25.25,0,0,0,.362-.279c-.268-1.088-.793-3.2-.793-3.2A.5.5,0,0,0,12.5,12.5H11a.5.5,0,0,0-.354.146,2.892,2.892,0,0,1-2.06.854H5.414a2.892,2.892,0,0,1-2.06-.854A.5.5,0,0,0,3,12.5H1.5a.5.5,0,0,0-.485.379s-.525,2.11-.793,3.2A.251.251,0,0,0,.312,16.333Z', 'M12,17H2a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2H12a2,2,0,0,0,2-2V19A2,2,0,0,0,12,17ZM4,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,4,22Zm6,0a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,10,22Z']],
  VrMonitorBox: ['vr-monitor-box', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.373,7.553a2.487,2.487,0,0,1,3.254,0l.986.845A2.5,2.5,0,0,0,14.24,9H18.5A2.5,2.5,0,0,0,21,6.5v-5A1.5,1.5,0,0,0,19.5,0H1.5A1.5,1.5,0,0,0,0,1.5v5A2.5,2.5,0,0,0,2.5,9H5.76a2.5,2.5,0,0,0,1.627-.6Z', 'M18.943,11.789h0l-3-1.25a.492.492,0,0,0-.384,0l-3,1.25h0a.546.546,0,0,0-.307.461v3.5a.5.5,0,0,0,.308.461l3,1.25a.492.492,0,0,0,.384,0l3-1.25a.5.5,0,0,0,.308-.461v-3.5A.546.546,0,0,0,18.943,11.789Zm-1.493.461-1.7.708-1.7-.708,1.7-.709Z', 'M24,11.75A1.752,1.752,0,0,0,22.25,10h-1a.75.75,0,0,0,0,1.5h1a.25.25,0,0,1,.25.25v6.5a.25.25,0,0,1-.25.25h-13A.25.25,0,0,1,9,18.25v-6.5a.25.25,0,0,1,.25-.25h2a.75.75,0,0,0,0-1.5h-2A1.752,1.752,0,0,0,7.5,11.75V19.5a1.752,1.752,0,0,0,1.75,1.75h5.5a.25.25,0,0,1,.25.25v.75a.25.25,0,0,1-.25.25h-1.5a.75.75,0,0,0,0,1.5h5a.75.75,0,0,0,0-1.5h-1.5a.25.25,0,0,1-.25-.25V21.5a.25.25,0,0,1,.25-.25h5.5A1.752,1.752,0,0,0,24,19.5Z']],
  VrPhone: ['vr-phone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6,8.5A.5.5,0,0,1,5.5,8V2.5A.5.5,0,0,1,6,2H18a.5.5,0,0,1,.5.5V8a.5.5,0,0,1-.5.5H14.75a.25.25,0,0,0-.25.25v1.5a.25.25,0,0,0,.25.25H18.5a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2H5.5a2,2,0,0,0-2,2V8.5a2,2,0,0,0,2,2H9.25a.25.25,0,0,0,.25-.25V8.75a.25.25,0,0,0-.25-.25Z', 'M21.5,15H16.084a.252.252,0,0,0-.19.087c-.444.517-2.124,2.178-2.124,2.178a2.5,2.5,0,0,1-3.54,0S8.55,15.6,8.106,15.087A.252.252,0,0,0,7.916,15H2.5a2,2,0,0,0-2,2v4a3,3,0,0,0,3,3H7.76a2,2,0,0,0,1.3-.482l.986-.845a3,3,0,0,1,3.9,0l.986.845a2,2,0,0,0,1.3.482H20.5a3,3,0,0,0,3-3V17A2,2,0,0,0,21.5,15Z', 'M11.47,16.03a.748.748,0,0,0,1.06,0l2-2A.75.75,0,0,0,14,12.75h-.75A.25.25,0,0,1,13,12.5v-5a1,1,0,0,0-2,0v5a.25.25,0,0,1-.25.25H10a.75.75,0,0,0-.53,1.28Z']],
  VrPlayDevice: ['vr-play-device', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.312,16.334a.25.25,0,0,0,.271.022A2.987,2.987,0,0,1,2,16H12a2.98,2.98,0,0,1,1.416.356.25.25,0,0,0,.362-.28c-.268-1.087-.793-3.2-.793-3.2A.5.5,0,0,0,12.5,12.5H11a.5.5,0,0,0-.354.146,2.894,2.894,0,0,1-2.061.854H5.414a2.929,2.929,0,0,1-2.06-.854A.5.5,0,0,0,3,12.5H1.5a.5.5,0,0,0-.485.379s-.525,2.11-.793,3.2A.252.252,0,0,0,.312,16.334Z', 'M12,17H2a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2H12a2,2,0,0,0,2-2V19A2,2,0,0,0,12,17ZM4.5,20h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Zm3,0h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Z', 'M22,0H13a2,2,0,0,0-2,2v8.75a.25.25,0,0,0,.25.25H12.5a2,2,0,0,1,1.94,1.515l.074.295a.25.25,0,0,0,.243.19H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM19.441,7.3l-3.033,1.82A.931.931,0,0,1,15,8.32V4.68a.93.93,0,0,1,1.408-.8L19.441,5.7a.928.928,0,0,1,0,1.595Z']],
  VrUserGlobeHuman: ['vr-user-globe-human', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,5.51a.5.5,0,0,0-.478-.5,7.49,7.49,0,0,0-4.341.973.5.5,0,0,0,.055.88l4.057,1.842A.5.5,0,0,0,24,8.25Z', 'M23.437,14.5l-8,1a.5.5,0,0,0-.409.329s-.544,1.538-.7,2.009a.5.5,0,0,0,.475.658h1.613a.25.25,0,0,1,.25.25v.564a2.6,2.6,0,0,0,2.593,2.593h.026a.25.25,0,0,1,.25.25V23.5a.5.5,0,0,0,.5.5H23.5a.5.5,0,0,0,.5-.5V15a.5.5,0,0,0-.169-.375A.491.491,0,0,0,23.437,14.5Z', 'M15.252,14l7.338-.443A1.5,1.5,0,0,0,24,12.059V11.2a1.506,1.506,0,0,0-.978-1.406L17.414,7.7a1.481,1.481,0,0,0-1.6.423,5.387,5.387,0,0,0-1.083,2.252,5.061,5.061,0,0,0,.038,3.345A.5.5,0,0,0,15.252,14Zm2.023-4.747,1.627.522a.5.5,0,0,1,.147.877L16.807,12.32a.5.5,0,0,1-.8-.429A5.728,5.728,0,0,1,16.7,9.469.5.5,0,0,1,17.275,9.252Z', 'M7,0a7,7,0,1,0,7,7A7.008,7.008,0,0,0,7,0ZM7,12a4.68,4.68,0,0,1-1.092-.14.248.248,0,0,1-.192-.24L5.688,9.25A3.754,3.754,0,0,0,2.76,5.964l-.366-.141a.25.25,0,0,1-.149-.308A4.994,4.994,0,0,1,7,2a4.634,4.634,0,0,1,.787.07.255.255,0,0,1,.183.137.251.251,0,0,1,0,.228l-.527.976a1.95,1.95,0,0,0,.294,2.382L9.07,7.13a.252.252,0,0,1,.066.238l-.172.686A1.934,1.934,0,0,0,9.183,9.53a1.814,1.814,0,0,0,1.005.822.251.251,0,0,1,.077.424A4.969,4.969,0,0,1,7,12Z']],
  VrUserController: ['vr-user-controller', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10,15H3a3,3,0,0,0-3,3v4.5a1.5,1.5,0,0,0,2.7.9l2.462-3.3a.252.252,0,0,1,.2-.1H7.634a.251.251,0,0,1,.2.1L10.3,23.4a1.5,1.5,0,0,0,2.7-.9V18A3,3,0,0,0,10,15Zm1.5,3.5a1,1,0,1,1-1-1A1,1,0,0,1,11.5,18.5Zm-8.751-1a1,1,0,1,1-1,1A1,1,0,0,1,2.75,17.5Z', 'M2.5,10.5H5.25a.25.25,0,0,1,.25.25V12.5a1,1,0,0,0,2,0V10A1.5,1.5,0,0,0,6,8.5H2.5a.5.5,0,0,1,0-1H7a1,1,0,0,0,0-2H2.5a2.5,2.5,0,0,0,0,5Z', 'M23.694,4.937A7,7,0,0,0,10.311,4.93,1.983,1.983,0,0,0,10,6V9a2,2,0,0,0,2,2h2.5a1,1,0,0,0,.8-.4l.9-1.2a1,1,0,0,1,1.6,0l.9,1.2a1,1,0,0,0,.8.4H22a2,2,0,0,0,2-2V6A1.989,1.989,0,0,0,23.694,4.937ZM14.5,7h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Zm3,0h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1ZM13.531,4a.25.25,0,0,1-.182-.421,5.022,5.022,0,0,1,7.312,0A.25.25,0,0,1,20.478,4Z', 'M21.455,12.639a1,1,0,0,0-1.4-.181,5.067,5.067,0,0,1-6.1,0,1,1,0,1,0-1.222,1.583,6.99,6.99,0,0,0,8.548,0A1,1,0,0,0,21.455,12.639Z']],
  VrUserLaptop: ['vr-user-laptop', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.5,10.5H5.25a.25.25,0,0,1,.25.25V12.5a1,1,0,0,0,2,0V10A1.5,1.5,0,0,0,6,8.5H2.5a.5.5,0,0,1,0-1H7a1,1,0,0,0,0-2H2.5a2.5,2.5,0,0,0,0,5Z', 'M11.5,21h-.25V16.5a2,2,0,0,0-2-2H2.75a2,2,0,0,0-2,2V21H.5a.5.5,0,0,0-.5.5A2.41,2.41,0,0,0,2.5,24h7A2.41,2.41,0,0,0,12,21.5.5.5,0,0,0,11.5,21ZM2.75,16.75A.25.25,0,0,1,3,16.5H9a.249.249,0,0,1,.25.25v4A.25.25,0,0,1,9,21H3a.25.25,0,0,1-.25-.25Z', 'M22,11a2,2,0,0,0,2-2V6a1.989,1.989,0,0,0-.306-1.063A7,7,0,0,0,10.311,4.93,1.983,1.983,0,0,0,10,6V9a2,2,0,0,0,2,2h2.5a1,1,0,0,0,.8-.4l.9-1.2a1,1,0,0,1,1.6,0l.9,1.2a1,1,0,0,0,.8.4ZM14.5,7h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Zm3,0h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1ZM13.531,4a.25.25,0,0,1-.182-.421,5.022,5.022,0,0,1,7.312,0A.25.25,0,0,1,20.478,4Z', 'M21.455,12.639a1,1,0,0,0-1.4-.181,5.067,5.067,0,0,1-6.1,0,1,1,0,1,0-1.222,1.583,6.99,6.99,0,0,0,8.548,0A1,1,0,0,0,21.455,12.639Z']],
  VrUserPlay: ['vr-user-play', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.82,19.541H8.326a.249.249,0,0,1-.25-.25V17a1.247,1.247,0,1,0-2.493,0V20.73a.25.25,0,0,1-.433.17l-.357-.383-.008-.009A1.247,1.247,0,0,0,2.867,22.1l0,0L4.31,23.9a.25.25,0,0,0,.2.094h7.973a.251.251,0,0,0,.25-.25v-1.3A2.911,2.911,0,0,0,9.82,19.541Z', 'M13.447,3.105l-6-3a1,1,0,0,0-.894,0l-6,3A1.058,1.058,0,0,0,0,4v6.75a1,1,0,0,0,.553.894l6,3a1,1,0,0,0,.894,0l6-3A1,1,0,0,0,14,10.75V4A1.058,1.058,0,0,0,13.447,3.105Zm-3.131.671a.25.25,0,0,1,0,.448l-3.2,1.6a.252.252,0,0,1-.224,0l-3.2-1.6a.25.25,0,0,1,0-.448l3.2-1.6a.252.252,0,0,1,.224,0ZM2,6.023a.25.25,0,0,1,.119-.213A.248.248,0,0,1,2.362,5.8l3.5,1.75A.251.251,0,0,1,6,7.773v3.954a.25.25,0,0,1-.362.224l-3.5-1.75A.251.251,0,0,1,2,9.977Zm6.362,5.928A.25.25,0,0,1,8,11.727V7.773a.251.251,0,0,1,.138-.224l3.5-1.75a.248.248,0,0,1,.243.011A.25.25,0,0,1,12,6.023V9.977a.251.251,0,0,1-.138.224Z', 'M24,5.51a.5.5,0,0,0-.478-.5,7.473,7.473,0,0,0-4.341.973.5.5,0,0,0,.055.88l4.057,1.842A.5.5,0,0,0,24,8.25Z', 'M23.438,14.5l-8,1a.5.5,0,0,0-.41.329s-.544,1.538-.7,2.009a.5.5,0,0,0,.475.658h1.613a.25.25,0,0,1,.25.25v.564a2.6,2.6,0,0,0,2.593,2.593h.026a.25.25,0,0,1,.25.25V23.5a.5.5,0,0,0,.5.5H23.5a.5.5,0,0,0,.5-.5V15a.5.5,0,0,0-.169-.375A.49.49,0,0,0,23.438,14.5Z', 'M15.222,14h.03l7.338-.443A1.5,1.5,0,0,0,24,12.059V11.2a1.506,1.506,0,0,0-.978-1.406L17.414,7.7a1.481,1.481,0,0,0-1.6.423,5.387,5.387,0,0,0-1.083,2.252,5.061,5.061,0,0,0,.038,3.345A.5.5,0,0,0,15.222,14Zm2.053-4.748,1.627.522a.5.5,0,0,1,.147.877L16.807,12.32a.5.5,0,0,1-.8-.429A5.728,5.728,0,0,1,16.7,9.469.5.5,0,0,1,17.275,9.252Z']],
  VrVideo11: ['vr-video-1_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H13a2,2,0,0,0-2,2v8.75a.25.25,0,0,0,.25.25H12.5a2,2,0,0,1,1.94,1.515l.074.3a.25.25,0,0,0,.243.189H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM19.894,6.5a.935.935,0,0,1-.453.8l-3.033,1.82A.931.931,0,0,1,15,8.32V4.68a.93.93,0,0,1,1.408-.8L19.441,5.7A.933.933,0,0,1,19.894,6.5Z', 'M12.985,12.879A.5.5,0,0,0,12.5,12.5H11a.5.5,0,0,0-.354.146,2.894,2.894,0,0,1-2.061.854H5.414a2.929,2.929,0,0,1-2.06-.854A.5.5,0,0,0,3,12.5H1.5a.5.5,0,0,0-.485.379s-.525,2.11-.793,3.2a.253.253,0,0,0,.09.258.25.25,0,0,0,.271.022A2.987,2.987,0,0,1,2,16H12a2.98,2.98,0,0,1,1.416.356.25.25,0,0,0,.362-.28C13.51,14.989,12.985,12.879,12.985,12.879Z', 'M14,19a2,2,0,0,0-2-2H2a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2H12a2,2,0,0,0,2-2ZM2.5,20.5A1.5,1.5,0,1,1,4,22,1.5,1.5,0,0,1,2.5,20.5Zm6,0A1.5,1.5,0,1,1,10,22,1.5,1.5,0,0,1,8.5,20.5Z']],
  Controller360: ['controller-360', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.023,8H21.977a2.511,2.511,0,0,1,.907.169.25.25,0,0,0,.324-.323L21.467,3.32A.5.5,0,0,0,21,3H19a.492.492,0,0,0-.257.071A10.027,10.027,0,0,1,13.585,4.5h-3.17A10.027,10.027,0,0,1,5.257,3.071.492.492,0,0,0,5,3H3a.5.5,0,0,0-.467.32L.792,7.846a.25.25,0,0,0,.324.323A2.511,2.511,0,0,1,2.023,8Z', 'M10.958,16.25a.625.625,0,0,0,.625.625h.834a.625.625,0,1,0,0-1.25H11.208a.25.25,0,0,0-.25.25Z', 'M17.833,13.125a1.042,1.042,0,0,0-1.041,1.041v1.667a1.042,1.042,0,1,0,2.083,0V14.166A1.043,1.043,0,0,0,17.833,13.125Z', 'M23.5,10.523A1.523,1.523,0,0,0,21.977,9H2.023A1.523,1.523,0,0,0,.5,10.523v8.954A1.523,1.523,0,0,0,2.023,21H21.977A1.523,1.523,0,0,0,23.5,19.477Zm-16.917,5.1H4.5a.625.625,0,0,1,0-1.25H6.583a.625.625,0,0,0,0-1.25H4.5a.625.625,0,0,1,0-1.25H6.583A1.873,1.873,0,0,1,8.1,14.852a.251.251,0,0,0,0,.295,1.874,1.874,0,0,1-1.515,2.978H4.5a.625.625,0,0,1,0-1.25H6.583a.625.625,0,0,0,0-1.25Zm5.834-1.25a1.875,1.875,0,1,1,0,3.75h-.834A1.877,1.877,0,0,1,9.708,16.25v-2.5a1.877,1.877,0,0,1,1.875-1.875h2.084a.625.625,0,1,1,0,1.25H11.583a.625.625,0,0,0-.625.625v.375a.25.25,0,0,0,.25.25Zm7.708,1.458a2.292,2.292,0,1,1-4.583,0V14.166a2.292,2.292,0,0,1,4.583,0Z']],
  VrVideo1: ['vr-video-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13,12.5H11.5a.5.5,0,0,0-.485.379s-.525,2.11-.793,3.2a.251.251,0,0,0,.362.28A2.98,2.98,0,0,1,12,16H22a2.98,2.98,0,0,1,1.416.356.25.25,0,0,0,.362-.279c-.268-1.088-.793-3.2-.793-3.2A.5.5,0,0,0,22.5,12.5H21a.5.5,0,0,0-.354.146,2.892,2.892,0,0,1-2.06.854H15.414a2.892,2.892,0,0,1-2.06-.854A.5.5,0,0,0,13,12.5Z', 'M22,17H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V19A2,2,0,0,0,22,17Zm-8,5a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,14,22Zm6,0a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,20,22Z', 'M3.731,5.8,6.206,6.863a.5.5,0,0,0,.657-.657L5.8,3.731A.522.522,0,0,0,5.7,3.575L2.268.146a.5.5,0,0,0-.707,0L.146,1.56a.5.5,0,0,0,0,.708L3.575,5.7A.5.5,0,0,0,3.731,5.8Z', 'M11.5,11.5H13a1.5,1.5,0,0,1,1.061.439,1.857,1.857,0,0,0,.3.246.249.249,0,0,0,.387-.208V7.54a.753.753,0,0,0-.486-.7L8.823,4.8A.75.75,0,1,0,8.3,6.2l3.651,1.369L8,9.189,2.284,6.846A.75.75,0,0,0,1.25,7.54V14a.75.75,0,0,0,.513.711l6,2a.74.74,0,0,0,.474,0l.737-.245a.251.251,0,0,0,.164-.178c.165-.677.907-3.652.907-3.652A1.5,1.5,0,0,1,11.5,11.5Z']],
  VrLaptop1: ['vr-laptop-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.312,3.833a.25.25,0,0,0,.272.023A2.98,2.98,0,0,1,12,3.5H22a2.98,2.98,0,0,1,1.416.356.25.25,0,0,0,.362-.279c-.268-1.088-.793-3.2-.793-3.2A.5.5,0,0,0,22.5,0H21a.5.5,0,0,0-.354.146A2.892,2.892,0,0,1,18.586,1H15.414a2.892,2.892,0,0,1-2.06-.854A.5.5,0,0,0,13,0H11.5a.5.5,0,0,0-.485.379s-.525,2.11-.793,3.2A.251.251,0,0,0,10.312,3.833Z', 'M22,4.5H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h8v9a.5.5,0,0,1-1,0v-2A2.5,2.5,0,0,0,16.5,16H14a1,1,0,0,0,0,2h2.5a.5.5,0,0,1,.5.5v2a2.5,2.5,0,0,0,5,0v-9a2,2,0,0,0,2-2v-3A2,2,0,0,0,22,4.5Zm-8,5A1.5,1.5,0,1,1,15.5,8,1.5,1.5,0,0,1,14,9.5Zm6,0A1.5,1.5,0,1,1,21.5,8,1.5,1.5,0,0,1,20,9.5Z', 'M11.5,21h-.25V16.5a2,2,0,0,0-2-2H2.75a2,2,0,0,0-2,2V21H.5a.5.5,0,0,0-.5.5A2.41,2.41,0,0,0,2.5,24h7A2.41,2.41,0,0,0,12,21.5.5.5,0,0,0,11.5,21Zm-2.25-.25A.25.25,0,0,1,9,21H3a.25.25,0,0,1-.25-.25v-4A.25.25,0,0,1,3,16.5l6,0a.252.252,0,0,1,.177.074.248.248,0,0,1,.073.176Z']],
  VrGlobe: ['vr-globe', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,14h-.313a.249.249,0,0,0-.226.144,10.983,10.983,0,0,1-19.922,0A.249.249,0,0,0,1.813,14H1.5A1.5,1.5,0,0,0,0,15.5v6A2.5,2.5,0,0,0,2.5,24H7.76a2.5,2.5,0,0,0,1.627-.6l.986-.845a2.487,2.487,0,0,1,3.254,0l.986.845a2.5,2.5,0,0,0,1.627.6H21.5A2.5,2.5,0,0,0,24,21.5v-6A1.5,1.5,0,0,0,22.5,14Z', 'M12,19H12A9.5,9.5,0,1,0,12,19Zm4.039-3.19a.25.25,0,0,1-.357-.325,10.724,10.724,0,0,0,.766-1.97.252.252,0,0,1,.241-.182h1.294a.251.251,0,0,1,.206.392A7.545,7.545,0,0,1,16.034,15.81ZM9.7,13.67a.252.252,0,0,1,.235-.337h4.122a.252.252,0,0,1,.235.337,6.627,6.627,0,0,1-2.145,3.068.249.249,0,0,1-.3,0A6.623,6.623,0,0,1,9.7,13.67ZM4.5,9.5a7.379,7.379,0,0,1,.189-1.639.25.25,0,0,1,.244-.195H6.865a.248.248,0,0,1,.185.083.254.254,0,0,1,.064.192,15.043,15.043,0,0,0,0,3.118.254.254,0,0,1-.064.192.249.249,0,0,1-.186.082H4.933a.25.25,0,0,1-.244-.194A7.379,7.379,0,0,1,4.5,9.5Zm4.533,0a14.1,14.1,0,0,1,.091-1.612.25.25,0,0,1,.248-.222h5.256a.25.25,0,0,1,.248.222A14.1,14.1,0,0,1,14.967,9.5a14.333,14.333,0,0,1-.091,1.612.249.249,0,0,1-.248.221H9.372a.249.249,0,0,1-.248-.221A14.1,14.1,0,0,1,9.033,9.5ZM11.85,2.263a.249.249,0,0,1,.3,0A6.619,6.619,0,0,1,14.3,5.33a.25.25,0,0,1-.235.336H9.939a.249.249,0,0,1-.234-.336A6.623,6.623,0,0,1,11.85,2.263ZM19.5,9.5a7.379,7.379,0,0,1-.189,1.639.249.249,0,0,1-.244.194H17.136a.249.249,0,0,1-.186-.082.254.254,0,0,1-.064-.192,15.043,15.043,0,0,0,0-3.118.258.258,0,0,1,.064-.193.253.253,0,0,1,.186-.082h1.931a.251.251,0,0,1,.244.195A7.379,7.379,0,0,1,19.5,9.5ZM16.684,5.666a.251.251,0,0,1-.241-.181,10.724,10.724,0,0,0-.766-1.97.25.25,0,0,1,.357-.325,7.545,7.545,0,0,1,2.15,2.085.25.25,0,0,1-.206.391ZM7.966,3.19a.25.25,0,0,1,.357.325,10.724,10.724,0,0,0-.766,1.97.251.251,0,0,1-.241.181H6.022A.249.249,0,0,1,5.8,5.533a.252.252,0,0,1,.015-.258A7.545,7.545,0,0,1,7.966,3.19Zm-.65,10.143a.252.252,0,0,1,.241.182,10.724,10.724,0,0,0,.766,1.97.25.25,0,0,1-.357.325,7.545,7.545,0,0,1-2.15-2.085.251.251,0,0,1,.206-.392Z']],
  VrHeadphones: ['vr-headphones', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2,16H12a2.98,2.98,0,0,1,1.416.356.25.25,0,0,0,.362-.279c-.268-1.088-.793-3.2-.793-3.2A.5.5,0,0,0,12.5,12.5H11a.5.5,0,0,0-.354.146,2.892,2.892,0,0,1-2.06.854H5.414a2.892,2.892,0,0,1-2.06-.854A.5.5,0,0,0,3,12.5H1.5a.5.5,0,0,0-.485.379s-.525,2.11-.793,3.2a.25.25,0,0,0,.362.28A2.98,2.98,0,0,1,2,16Z', 'M12,17H2a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2H12a2,2,0,0,0,2-2V19A2,2,0,0,0,12,17ZM2.5,19h2a.5.5,0,0,1,0,1h-2a.5.5,0,0,1,0-1Zm5.5.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1,0-1h1A.5.5,0,0,1,8,19.5Z', 'M24,7.975A1.977,1.977,0,0,0,22.025,6,.025.025,0,0,1,22,5.975V5.95a6,6,0,0,0-12,0v.025A.025.025,0,0,1,9.975,6,1.977,1.977,0,0,0,8,7.975v1.05A1.977,1.977,0,0,0,9.975,11H11.5a.5.5,0,0,0,.5-.5V5.95a4,4,0,0,1,8,0V10.5a.5.5,0,0,0,.333.472.249.249,0,0,1,.167.235V17.5a.5.5,0,0,1-1,0v-2A2.5,2.5,0,0,0,17,13H16a1,1,0,0,0,0,2h1a.5.5,0,0,1,.5.5v2a2.5,2.5,0,0,0,5,0V11.128a.251.251,0,0,1,.168-.236A1.977,1.977,0,0,0,24,9.025Z']],
  VrUserBox: ['vr-user-box', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.731,5.8,6.206,6.863a.5.5,0,0,0,.657-.657L5.8,3.731A.522.522,0,0,0,5.7,3.575L2.268.146a.5.5,0,0,0-.707,0L.146,1.56a.5.5,0,0,0,0,.708L3.575,5.7A.5.5,0,0,0,3.731,5.8Z', 'M10.045,12.636A1.5,1.5,0,0,1,11.5,11.5H13a1.5,1.5,0,0,1,1.061.439,1.918,1.918,0,0,0,.3.247.25.25,0,0,0,.387-.209V7.54a.753.753,0,0,0-.486-.7L8.823,4.8A.75.75,0,1,0,8.3,6.2l3.055,1.146a.25.25,0,0,1,.007.465L8.1,9.151a.26.26,0,0,1-.19,0l-5.621-2.3A.75.75,0,0,0,1.25,7.54V14a.75.75,0,0,0,.513.711l6,2a.74.74,0,0,0,.474,0l.737-.245a.249.249,0,0,0,.164-.178C9.3,15.611,10.045,12.636,10.045,12.636Z', 'M10.222,16.076a.25.25,0,0,0,.362.28A2.98,2.98,0,0,1,12,16H22a2.98,2.98,0,0,1,1.416.356.25.25,0,0,0,.362-.279c-.268-1.088-.793-3.2-.793-3.2A.5.5,0,0,0,22.5,12.5H21a.5.5,0,0,0-.354.146,2.892,2.892,0,0,1-2.06.854H15.414a2.892,2.892,0,0,1-2.06-.854A.5.5,0,0,0,13,12.5H11.5a.5.5,0,0,0-.485.379S10.49,14.989,10.222,16.076Z', 'M22,17H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V19A2,2,0,0,0,22,17Zm-4,2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1,0-1h1A.5.5,0,0,1,18,19.5Zm-3,0a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1,0-1h2A.5.5,0,0,1,15,19.5Z']],
  VrUserPlay1: ['vr-user-play-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H13a2,2,0,0,0-2,2V8.286a.25.25,0,0,0,.135.222,9.054,9.054,0,0,1,4.092,4.344.25.25,0,0,0,.229.148H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM19.894,6.5a.935.935,0,0,1-.453.8l-3.033,1.82A.931.931,0,0,1,15,8.32V4.68a.931.931,0,0,1,1.408-.8L19.441,5.7A.933.933,0,0,1,19.894,6.5Z', 'M7,9A6.994,6.994,0,0,0,.311,13.93,1.983,1.983,0,0,0,0,15v3a2,2,0,0,0,2,2H4.5a1,1,0,0,0,.8-.4l.9-1.2a1,1,0,0,1,1.6,0l.9,1.2a1,1,0,0,0,.8.4H12a2,2,0,0,0,2-2V15a1.989,1.989,0,0,0-.306-1.063A6.958,6.958,0,0,0,7,9ZM4.5,16h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Zm3,0h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1ZM3.531,13a.25.25,0,0,1-.182-.421,5.022,5.022,0,0,1,7.312,0,.25.25,0,0,1-.183.421Z', 'M11.147,21.447a1,1,0,0,0-1.385-.28,5.078,5.078,0,0,1-5.524,0,1,1,0,0,0-1.105,1.666,6.99,6.99,0,0,0,7.734,0A1,1,0,0,0,11.147,21.447Z']],
  VrUserHeadphones: ['vr-user-headphones', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.491,11.583a10.5,10.5,0,0,0-20.982,0A1.5,1.5,0,0,0,.5,13v3A1.5,1.5,0,0,0,2,17.5H3.5A.5.5,0,0,0,4,17V12a.5.5,0,0,0-.485-.5,8.5,8.5,0,0,1,16.97,0A.5.5,0,0,0,20,12v5a.5.5,0,0,0,.5.5H22A1.5,1.5,0,0,0,23.5,16V13A1.5,1.5,0,0,0,22.491,11.583Z', 'M12,7a7.02,7.02,0,0,0-6.584,4.619.981.981,0,0,0-.055.246A1.99,1.99,0,0,0,5,13.01v3a2,2,0,0,0,2,2H9.5a1,1,0,0,0,.8-.4l.9-1.2a1,1,0,0,1,1.6,0l.9,1.2a1,1,0,0,0,.8.4H17a2,2,0,0,0,2-2v-3a2,2,0,0,0-.307-1.065A7.013,7.013,0,0,0,12,7ZM9.5,14.01h-2a.5.5,0,1,1,0-1h2a.5.5,0,0,1,0,1Zm3,0h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Zm-3.971-3a.25.25,0,0,1-.183-.421,5,5,0,0,1,7.31,0,.25.25,0,0,1-.183.421Z', 'M15.052,19.458a5.067,5.067,0,0,1-6.1,0,1,1,0,1,0-1.222,1.583,6.99,6.99,0,0,0,8.548,0,1,1,0,1,0-1.222-1.583Z']]
};
exports["default"] = _default;